<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/en">Exhibition List</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>Chan Chao App
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <div class="MbDevice">
      <div class="homeLeft mt-5">
        <div class="UserAccount ml-1">
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
        <hr />
        <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
        <div class="expoInfo">
          <p class="bold" name="Exhibition"></p>
          <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
          <p>{{ eExhVenue }}</p>
        </div>
        <p class="clear"></p>
      </div>
    </div>
    <div class="articleEn">
      <div class="contentBox">
        <div>
          <!-- left -->
          <div class="proLeft NoShowInMobile align_c">
            <img src="@/assets/images/ccat.png" width="100%" />
          </div>
          <!-- left end -->
          <!-- right -->
          <div class="proRight">
            <div class="MbDevice">
              <!-- <h1><img src="@/assets/images/iconEdm.svg" width="35px" class="mb-1" /> Send e-Newsletter</h1> -->

              <div class="d-flex align-items-center">
                <div>
                  <img
                    src="@/assets/images/ccat.png"
                    width="35px"
                    class="mt-1 mr-1"
                  />
                </div>
                <div>
                  <h1>Chan Chao App</h1>
                </div>
              </div>
            </div>
            <div class="PcDevice">
              <h1>Chan Chao App</h1>
            </div>
            <p class="my-3">&nbsp;</p>
            <p>
              Join Chan Chao membership, experience our new Buyer's Get service
              for free!
            </p>

            <p class="my-3">&nbsp;</p>
            <ol>
              <li>
                Sign up to Chan Chao membership, create your personalized
                e-business card and gather valuable buyer information at no
                cost.
              </li>

              <li>
                By uploading company products and information, exhibitors can
                expand their reach on event websites and the Chan Chao App.
                Exhibitors can also participate in exclusive campaigns, opening
                up additional opportunities to engage with event visitors.

                <p class="red mt-1">
                  ( Do not forget to upload your company's information to gain
                  exposure on the digital floorplan, and be easily accessed by
                  event visitors )
                </p>
              </li>
            </ol>
            <p class="lightLine">&nbsp;</p>

            <h3>App Features Spotlight</h3>
            <p class="my-4">&nbsp;</p>

            <h2 class="mb-1 AppIntrofont red">Personal e-Business Card</h2>

            <p>
              Just one click and scan, easy to save information from exhibitors
              and clients
            </p>
            <p class="my-3">&nbsp;</p>
            <h2 class="mb-2 AppIntrofont red">Digital Floorplan</h2>

            <p>
              Discover exhibitors and products that spark your interest, the
              floorplan will guide you to their booth locations
            </p>

            <p class="my-3">&nbsp;</p>

            <h2 class="mb-2 AppIntrofont red">Create Your Own Favorites</h2>

            <p>
              Best personal assistant for your purchase plan and research, with
              latest trends from diverse industries
            </p>
            <p class="my-3">&nbsp;</p>
            <h2 class="mb-2 AppIntrofont red">Take Notes at Exhibition</h2>

            <p>
              Recording with words, voices and photos, no more important message
              is missing out
            </p>
            <p class="my-3">&nbsp;</p>

            <h2 class="mb-2 AppIntrofont red">Speedy Event Entry</h2>

            <p>
              Simply display the admission QR code, faster to enjoy exhibitions
              you love!
            </p>

            <p class="lightLine">&nbsp;</p>
            <h3>Download Chan Chao App now!</h3>
            <p class="my-3">&nbsp;</p>

            <div class="row align-items-center">
              <div class="col-md-2 col-4">
                <img
                  src="https://www.chanchao.com.tw/images/event/ccapp_ios_en.jpg"
                  class="img-fluid"
                />
              </div>
              <div class="col-md-2 col-4">
                <img
                  src="https://www.chanchao.com.tw/images/event/ccapp_android_en.jpg"
                  class="img-fluid"
                />
              </div>
              <div class="col-md-2 col-4">
                <img
                  src="https://www.chanchao.com.tw/images/event/ccapp_apk_en.jpg"
                  class="img-fluid"
                />
              </div>
            </div>
            <p class="my-3">&nbsp;</p>
            Download for :

            <a
              target="_blank"
              class="linkstyle"
              href="https://apps.apple.com/tw/app/%E5%B1%95%E6%98%AD%E5%B1%95%E8%A6%BD-chan-chao-expo/id6448909182"
            >
              IOS
            </a>
            /
            <a
              target="_blank"
              class="linkstyle"
              href="https://play.google.com/store/apps/details?id=com.chanchaoofficialapp"
            >
              Android
            </a>

            /
            <a
              target="_blank"
              class="linkstyle"
              href="https://www.chanchao.com.tw/downloads/chanchao-app/chan-chao-expo-app-release.zip"
            >
              APK
            </a>

            <p class="my-3">&nbsp;</p>
            For more information :
            <a
              target="_blank"
              class="linkstyle"
              href="https://www.chanchao.com.tw/en/memberExpoApp.asp"
            >
              https://www.chanchao.com.tw/en/memberExpoApp.asp
            </a>
          </div>
          <p class="clear"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
// import '../../assets/validate'

export default {
  components: {},

  metaInfo() {
    return {
      title: `Chan Chao App - Chan Chao Exhibitor's Online Service System`,
    };
  },

  data() {
    return {
      UserId: "",
      CSRF_Token: "",
      RegNo: "",
      edmMail: "",
      edmLan: "en",
      lang: "en",

      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",
    };
  },

  methods: {},

  created() {
    const vm = this;

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1];

    let lang = "en";

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${lang}`,
      )
      .then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;
        vm.ExhBegin = response.data.Data.ExhBegin;
        vm.ExhEnd = response.data.Data.ExhEnd;
        vm.ExhVenue = response.data.Data.ExhVenue;
        vm.eExhVenue = response.data.Data.eExhVenue;
      });
  },
};
</script>

<style lang="scss">
ol {
  display: block;
  margin: 0px 20px;
  padding: 0px;
}

.AppIntrofont {
  font-weight: 500;
  font-size: 16px;
}
</style>
